import { Outlet } from 'react-router-dom';

type Props = {
  withImage?: boolean;
};

export default function AuthContainerLayout({ withImage }: Props) {
  return (
    <div className="flex items-center justify-center flex-1 md:p-4 lg:p-8 ">
      <>
        {withImage ? (
          <div className="flex align-middle max-w-[58rem] w-full justify-end bg-white">
            <div className="flex w-full flex-col items-stretch gap-0 md:grid md:grid-cols-[1fr_1.5fr] lg:grid-cols-2 ">
              <div className="hidden h-full w-full items-center justify-center bg-black md:flex">
                <img
                  src="/assets/login-image.svg"
                  alt="Armada illustration"
                  className="h-full w-full max-w-[34rem] object-contain p-8 md:p-10 lg:p-12"
                />
              </div>
              <div className="flex items-center  md:min-h-[38rem] justify-center ">
                <Outlet />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex align-middle bg-white">
            <div>
              <Outlet />
            </div>
          </div>
        )}
      </>
    </div>
  );
}
